import {React, classNames} from '@api'
import {SvgIcon, Tooltip} from '@material-ui/core'
import {SvgIconProps} from '@material-ui/core/SvgIcon'
import * as css from './customIcons.css'

export class AddIcon extends React.Component<SvgIconProps> {
  static defaultProps = {
    viewBox: '0 0 24 24'
  }

  render() {
    const {className, ...props} = this.props

    return (
      <SvgIcon className={classNames(css.root, className)} {...props}>
        <path
          d='M6,2 L18,2 C20.209139,2 22,3.790861 22,6 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,6 C2,3.790861 3.790861,2 6,2 Z M6,4 C4.8954305,4 4,4.8954305 4,6 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,6 C20,4.8954305 19.1045695,4 18,4 L6,4 Z M13,11 L17,11 L17,13 L13,13 L13,17 L11,17 L11,13 L7,13 L7,11 L11,11 L11,7 L13,7 L13,11 Z'
        />
      </SvgIcon>
    )
  }
}

export class AddManyIcon extends React.Component<SvgIconProps> {
  static defaultProps = {
    viewBox: '0 0 24 24'
  }

  render() {
    const {className, ...props} = this.props

    return (
      <SvgIcon className={classNames(css.root, className)} {...props}>
        <path
          d='M5,5 L16,5 C17.6568542,5 19,6.34314575 19,8 L19,19 C19,20.6568542 17.6568542,22 16,22 L5,22 C3.34314575,22 2,20.6568542 2,19 L2,8 C2,6.34314575 3.34314575,5 5,5 Z M5,7 C4.44771525,7 4,7.44771525 4,8 L4,19 C4,19.5522847 4.44771525,20 5,20 L16,20 C16.5522847,20 17,19.5522847 17,19 L17,8 C17,7.44771525 16.5522847,7 16,7 L5,7 Z M19,19 L19,17 C19.5522847,17 20,16.5522847 20,16 L20,5 C20,4.44771525 19.5522847,4 19,4 L8,4 C7.44771525,4 7,4.44771525 7,5 L5,5 C5,3.34314575 6.34314575,2 8,2 L19,2 C20.6568542,2 22,3.34314575 22,5 L22,16 C22,17.6568542 20.6568542,19 19,19 Z M11.4,12.6 L15,12.6 L15,14.4 L11.4,14.4 L11.4,18 L9.6,18 L9.6,14.4 L6,14.4 L6,12.6 L9.6,12.6 L9.6,9 L11.4,9 L11.4,12.6 Z'
        />
      </SvgIcon>
    )
  }
}

export class ToggleSidebarIcon extends React.Component<SvgIconProps> {
  static defaultProps = {
    viewBox: '0 0 18 18'
  }

  render() {
    const {className, ...props} = this.props

    return (
      <SvgIcon className={classNames(css.root, className)} {...props}>
        <path d={'M16,0 L2,0 C0.9,0 0.01,0.9 0.01,2 L0,14 C0,15.1 0.9,16 2,16 L16,16 C17.1,16 18,15.1 18,14 L18,2 C18,0.9 17.1,0 16,0 Z M11,14 L2,14 L2,10 L11,10 L11,14 Z M11,9 L2,9 L2,5 L11,5 L11,9 Z M16,14 L12,14 L12,5 L16,5 L16,14 Z'}/>
      </SvgIcon>
    )
  }
}

export class SortAscendingIcon extends React.Component<SvgIconProps> {
  static defaultProps = {
    viewBox: '0 0 18 18'
  }

  render() {
    const {className, ...props} = this.props

    return (
      <SvgIcon className={classNames(css.root, className)} {...props}>
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g id='sort-ascending' transform='translate(-1.000000, -3.000000)'>
            <g>
              <rect id='Rectangle' fillRule='nonzero' x='0' y='0' width='24' height='24'/>
              <path
                d='M10,11 L10,13 L18,13 L18,11 L10,11 Z M10,5 L10,7 L14,7 L14,5 L10,5 Z M10,17 L10,19 L22,19 L22,17 L10,17 Z M6,7 L8.5,7 L5,3.5 L1.5,7 L4,7 L4,20 L6,20 L6,7 Z'
                id='Shape' fill='#757575' fillRule='nonzero'/>
            </g>
          </g>
        </g>
      </SvgIcon>
    )
  }
}

export class SortDescendingIcon extends React.Component<SvgIconProps> {
  static defaultProps = {
    viewBox: '0 0 18 18'
  }

  render() {
    const {className, ...props} = this.props

    return (
      <SvgIcon className={classNames(css.root, className)} {...props}>
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g transform='translate(-580.000000, -87.000000)'>
            <g transform='translate(300.000000, 64.000000)'>
              <g id='ic/sort-descending' transform='translate(279.000000, 20.000000)'>
                <g>
                  <rect id='Rectangle' fillRule='nonzero' x='0' y='0' width='24' height='24'/>
                  <path
                    d='M10,11 L10,13 L18,13 L18,11 L10,11 Z M10,5 L10,7 L14,7 L14,5 L10,5 Z M10,17 L10,19 L22,19 L22,17 L10,17 Z M6,16.5 L8.5,16.5 L5,20 L1.5,16.5 L4,16.5 L4,3.5 L6,3.5 L6,16.5 Z'
                    id='Shape' fill='#757575' fillRule='nonzero'/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </SvgIcon>
    )
  }
}

export class YenIcon extends React.Component<SvgIconProps> {
  static defaultProps = {
    viewBox: '0 0 512 512'
  }

  render() {
    const {className, ...props} = this.props

    return (
      <SvgIcon className={classNames(css.root, css.yen, className)} {...props}>
        <g>
          <path
            d='M443.804,3.868C440.36,1.336,436.272,0,431.996,0c-6.352,0-12.396,3.056-16.152,8.18L256,226.248L96.16,8.18    C92.404,3.056,86.368,0,80.008,0C75.732,0,71.652,1.336,68.2,3.868c-8.904,6.528-10.84,19.032-4.316,27.92L216.532,240H83.944    c-11.028,0-20.008,8.964-20.008,20c0,11.028,8.98,20,20.008,20H236v64H83.944c-11.028,0-20.008,8.96-20.008,20    c0,11.024,8.98,20,20.008,20H236v107.992c0,11.036,8.972,20.008,20,20.008c11.036,0,20-8.972,20-20.008V384h151.568    c11.036,0,20.008-8.976,20.008-20c0-11.04-8.972-20-20.008-20H276v-64h151.568c11.036,0,20.008-8.972,20.008-20    c0-11.036-8.972-20-20.008-20H295.472L448.12,31.788C454.636,22.9,452.708,10.396,443.804,3.868z'/>
        </g>
      </SvgIcon>
    )
  }
}

export const WorkspaceIcon = () => <SvgIcon width='22' height='14' viewBox='0 0 22 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M21.6666 13.6668H16.3333V8.3335H21.6666V13.6668ZM13.6666 13.6668H8.33325V8.3335H13.6666V13.6668ZM5.66658 13.6668H0.333252V8.3335H5.66658V13.6668ZM21.6666 5.66683H16.3333V0.333496H21.6666V5.66683ZM13.6666 5.66683H8.33325V0.333496H13.6666V5.66683ZM5.66658 5.66683H0.333252V0.333496H5.66658V5.66683Z' fill='#828282'/>
</SvgIcon>

export const SeasonIcon = () => <SvgIcon width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path
    d='M22 27.3332C19.0777 27.3261 16.7024 24.974 16.6667 22.0519V19.3332H11.3334V22.0265C11.3186 24.9685 8.92436 27.343 5.98233 27.3332C3.04031 27.3234 0.661884 24.9331 0.666756 21.991C0.671642 19.049 3.05798 16.6666 6.00002 16.6665H8.66669V11.3332H6.00002C3.05798 11.3332 0.671642 8.95075 0.666756 6.00871C0.661884 3.06668 3.04031 0.676359 5.98233 0.666534C8.92436 0.65677 11.3186 3.0312 11.3334 5.9732V8.66653H16.6667V5.99987C16.6667 3.05435 19.0545 0.666534 22 0.666534C24.9455 0.666534 27.3334 3.05435 27.3334 5.99987C27.3334 8.94539 24.9455 11.3332 22 11.3332H19.3334V16.6665H22C24.9455 16.6665 27.3334 19.0543 27.3334 21.9999C27.3334 24.9454 24.9455 27.3332 22 27.3332ZM19.3334 19.3332V21.9999C19.3334 23.4726 20.5273 24.6665 22 24.6665C23.4728 24.6665 24.6667 23.4726 24.6667 21.9999C24.6667 20.5271 23.4728 19.3332 22 19.3332H19.3334ZM6.00002 19.3332C4.52726 19.3332 3.33336 20.5271 3.33336 21.9999C3.33336 23.4726 4.52726 24.6665 6.00002 24.6665C6.70956 24.6741 7.39224 24.3956 7.89399 23.8938C8.39574 23.3921 8.67426 22.7094 8.66669 21.9999V19.3332H6.00002ZM11.3334 11.3332V16.6665H16.6667V11.3332H11.3334ZM22 3.3332C21.2905 3.32563 20.6078 3.60415 20.1061 4.1059C19.6043 4.60765 19.3258 5.29033 19.3334 5.99987V8.66653H22C22.7096 8.6741 23.3922 8.39558 23.894 7.89384C24.3957 7.39209 24.6743 6.70941 24.6667 5.99987C24.6743 5.29033 24.3957 4.60765 23.894 4.1059C23.3922 3.60415 22.7096 3.32563 22 3.3332ZM6.00002 3.3332C5.29048 3.32563 4.6078 3.60415 4.10605 4.1059C3.60431 4.60765 3.32579 5.29033 3.33336 5.99987C3.32579 6.70941 3.60431 7.39209 4.10605 7.89384C4.6078 8.39558 5.29048 8.6741 6.00002 8.66653H8.66669V5.99987C8.67426 5.29033 8.39574 4.60765 7.89399 4.1059C7.39224 3.60415 6.70956 3.32563 6.00002 3.3332Z'
    fill='#828282'/>
</SvgIcon>

export const ModalIcon = () => <SvgIcon width='28' height='24' viewBox='0 0 28 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M24.6667 24H3.33341C1.86066 24 0.666748 22.8061 0.666748 21.3333V2.66667C0.666748 1.19391 1.86066 0 3.33341 0H24.6667C26.1395 0 27.3334 1.19391 27.3334 2.66667V21.3333C27.3334 22.8061 26.1395 24 24.6667 24ZM3.33341 5.33333V21.3333H24.6667V5.33333H3.33341Z' fill='#828282'/>
</SvgIcon>

export const SidebarIcon = () => <SvgIcon width='28' height='24' viewBox='0 0 28 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M24.6667 24H3.33341C1.86066 24 0.666748 22.8061 0.666748 21.3333V2.66667C0.666748 1.19391 1.86066 0 3.33341 0H24.6667C26.1395 0 27.3334 1.19391 27.3334 2.66667V21.3333C27.3334 22.8061 26.1395 24 24.6667 24ZM11.3334 5.33333V21.3333H24.6667V5.33333H11.3334ZM3.33341 5.33333V21.3333H8.66675V5.33333H3.33341Z' fill='#828282'/>
</SvgIcon>

export const ChangeLogFilterIcon = (p?) => <SvgIcon width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path
    d='M17 0H1C0.447 0 0 0.447 0 1V3.59C0 4.113 0.213 4.627 0.583 4.997L6 10.414V18C6 18.347 6.18 18.668 6.475 18.851C6.635 18.95 6.817 19 7 19C7.153 19 7.306 18.965 7.447 18.895L11.447 16.895C11.786 16.725 12 16.379 12 16V10.414L17.417 4.997C17.787 4.627 18 4.113 18 3.59V1C18 0.447 17.553 0 17 0ZM10.293 9.293C10.105 9.48 10 9.734 10 10V15.382L8 16.382V10C8 9.734 7.895 9.48 7.707 9.293L2 3.59V2H16.001L16.003 3.583L10.293 9.293Z'
    fill='#2E3A59'/>
</SvgIcon>

export const ChangeLogSortIcon = (p?) => <SvgIcon width='12' height='14' viewBox='0 0 12 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M11.3922 8.99999L8.72556 12.3333L6.05889 8.99999L8.05889 8.99999L8.05889 0.333322L9.39222 0.333322L9.39222 8.99999L11.3922 8.99999ZM6.05889 4.99999L4.05889 4.99999L4.05889 13.6667L2.72556 13.6667L2.72556 4.99999L0.725555 4.99999L3.39222 1.66666L6.05889 4.99999Z' fill='#4F4F4F'/>
</SvgIcon>

export const PdfSvgIcon = (p?) => <SvgIcon {...p} className={classNames(p?.className, css.pdf)} viewBox='0 0 91 91'>
  <g xmlns='http://www.w3.org/2000/svg'>
    <g>
      <path d='M45.182,37.845c-1.118,0-1.842,0.099-2.269,0.197v14.502c0.427,0.099,1.118,0.099,1.743,0.099    c4.538,0.032,7.497-2.467,7.497-7.76C52.186,40.279,49.488,37.845,45.182,37.845z'/>
      <path d='M25.817,37.78c-1.021,0-1.71,0.099-2.072,0.197v6.543c0.428,0.099,0.953,0.132,1.677,0.132    c2.664,0,4.308-1.348,4.308-3.617C29.73,38.996,28.317,37.78,25.817,37.78z'/>
      <path
        d='M58.984,0H12.336v91h66.529V27.05L55.23,10.73L58.984,0z M32.656,46.165c-1.71,1.61-4.241,2.335-7.2,2.335    c-0.659,0-1.25-0.033-1.711-0.1v7.924H18.78V34.459c1.545-0.264,3.715-0.461,6.773-0.461c3.091,0,5.294,0.592,6.775,1.776    c1.414,1.118,2.367,2.959,2.367,5.129C34.695,43.074,33.971,44.915,32.656,46.165z M60.764,34.163h13.549v4.11h-8.517v5.063h7.958    v4.076h-7.958v8.912h-5.032V34.163z M57.479,44.717c0,4.242-1.543,7.168-3.682,8.977c-2.335,1.94-5.887,2.862-10.226,2.862    c-2.598,0-4.44-0.166-5.689-0.329V34.459c1.842-0.296,4.242-0.461,6.775-0.461c4.208,0,6.938,0.756,9.076,2.369    C56.033,38.076,57.479,40.805,57.479,44.717z'/>
      <polygon points='63.652,0 60.613,8.694 78.865,21.297   '/>
    </g>
  </g>
</SvgIcon>

export const ExcludeEye = () => <SvgIcon width='20' height='19' viewBox='0 0 20 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path
    d='M17.97 18.385L14.614 15.029C13.1661 15.6882 11.5908 16.0204 10 16.002C8.35988 16.0223 6.73671 15.6684 5.254 14.967C4.10468 14.4062 3.07264 13.6317 2.213 12.685C1.30049 11.7068 0.583297 10.5633 0.1 9.31595L0 9.00195L0.105 8.68595C0.82781 6.84224 2.04426 5.23312 3.621 4.03495L1 1.41395L2.413 0.00195312L19.382 16.971L17.972 18.385H17.97ZM5.036 5.45095C3.75792 6.34687 2.74865 7.57466 2.117 9.00195C3.47142 12.1269 6.59587 14.1086 10 14.002C11.0498 14.0106 12.0936 13.8415 13.087 13.502L11.287 11.702C10.8863 11.8984 10.4462 12.0009 10 12.002C8.34746 11.9916 7.01037 10.6545 7 9.00195C7.00048 8.55472 7.10309 8.1135 7.3 7.71195L5.036 5.45095ZM17.852 12.612L16.46 11.221C17.0456 10.5589 17.5256 9.8104 17.883 9.00195C16.5304 5.87553 13.4047 3.89303 10 4.00195C9.753 4.00195 9.505 4.01095 9.265 4.02795L7.5 2.26095C8.32163 2.08519 9.15979 1.99835 10 2.00195C11.6401 1.9816 13.2633 2.33557 14.746 3.03695C15.8953 3.59769 16.9274 4.37215 17.787 5.31895C18.6991 6.29592 19.4163 7.43803 19.9 8.68395L20 9.00195L19.895 9.31795C19.4268 10.536 18.7342 11.6554 17.853 12.618L17.852 12.612Z'
    fill='#828282'/>
</SvgIcon>

/*
 <SvgIcon onClick={() => onClickToggleSortBy(sortBy.order === 'ASC' ? 'DESC' : 'ASC')} classes={{root: classes.sortIcon}}>
                {sortBy.order === 'ASC' ?  : }
              </SvgIcon>
 */
/*
 <IconButton className={classes.button} aria-label="MassCreate" onClick={onClickMassCreation}>
                <SvgIcon classes={{root: classes.createIcon}} data-variant='fab' className={classes.button}>
                  <path
                    d="M5,5 L16,5 C17.6568542,5 19,6.34314575 19,8 L19,19 C19,20.6568542 17.6568542,22 16,22 L5,22 C3.34314575,22 2,20.6568542 2,19 L2,8 C2,6.34314575 3.34314575,5 5,5 Z M5,7 C4.44771525,7 4,7.44771525 4,8 L4,19 C4,19.5522847 4.44771525,20 5,20 L16,20 C16.5522847,20 17,19.5522847 17,19 L17,8 C17,7.44771525 16.5522847,7 16,7 L5,7 Z M19,19 L19,17 C19.5522847,17 20,16.5522847 20,16 L20,5 C20,4.44771525 19.5522847,4 19,4 L8,4 C7.44771525,4 7,4.44771525 7,5 L5,5 C5,3.34314575 6.34314575,2 8,2 L19,2 C20.6568542,2 22,3.34314575 22,5 L22,16 C22,17.6568542 20.6568542,19 19,19 Z M11.4,12.6 L15,12.6 L15,14.4 L11.4,14.4 L11.4,18 L9.6,18 L9.6,14.4 L6,14.4 L6,12.6 L9.6,12.6 L9.6,9 L11.4,9 L11.4,12.6 Z" id="path-1"></path>
                </SvgIcon>
              </IconButton>
 */


// WEBPACK FOOTER //
// ./src/stores/ui/customIcons.tsx